import { isBefore, subMonths } from 'date-fns';
import { PeriodType } from '../../types/prompt/PeriodType';

/**
 * Gradacja, z jaką otwiera się projekt. Lustro `ProjectService.calculateDefaultPeriod` z llm-common:
 * projekt zbierający dane dłużej niż miesiąc startuje na `WEEKLY`, młodszy na `DAILY`.
 *
 * Backend liczy ją TYLKO dla list projektów (`getProjectsByAccountId`), nie dla `getProjectById` —
 * strony pracujące na pojedynczym projekcie muszą policzyć ją same z zakresu dat, inaczej dostają
 * `undefined` i lądują na `DAILY` niezależnie od wieku projektu.
 */
export const defaultProjectPeriod = (oldestDate?: Date | string | null): PeriodType => {
  if (!oldestDate) {
    return 'DAILY';
  }

  const oldest = typeof oldestDate === 'string' ? new Date(oldestDate) : oldestDate;
  if (Number.isNaN(oldest.getTime())) {
    return 'DAILY';
  }

  return isBefore(oldest, subMonths(new Date(), 1)) ? 'WEEKLY' : 'DAILY';
};
